import news_announcements from "../assets/img/components/news_announcements.svg";
import manage_staff from "../assets/img/components/manage_staff.svg";
import manage_speakers from "../assets/img/components/manage_speakers.svg";
import content_builder from "../assets/img/components/content_builder.svg";

export const AnnouncementIcon = news_announcements,
  StaffIcon = manage_staff,
  SpeakerIcon = manage_speakers,
  ContentIcon = content_builder;



// WEBPACK FOOTER //
// ./src/utils/constants.js